import { memo, useState } from 'react';
import { Controller } from 'react-hook-form';
import { Autocomplete, TextField, Popper, autocompleteClasses } from '@mui/material';
import { styled } from '@mui/material/styles';
import classes from './styles.module.scss';

interface CustomMultiYearPickerProps {
  label?: string;
  errorMessage?: string;
  name?: string;
  control?: any;
  yearOptions?: number[]; // <-- năm truyền vào
  value?: number[];
  placeholder?: string;
  onChange?: (value: number[]) => void;
  [key: string]: any;
}

// Custom Popper để style dropdown
const StyledPopper = styled(Popper)({
  [`& .${autocompleteClasses.paper}`]: {
    marginTop: 8,
    width: 300,
  },
});

const CustomMultiYearPicker = memo((props: CustomMultiYearPickerProps) => {
  const { label, errorMessage, name, control,placeholder, yearOptions = [], value: propValue, onChange: propOnChange } = props;

  const [localValue, setLocalValue] = useState<number[]>(propValue || []);

  const handleChange = (newValue: number[]) => {
    setLocalValue(newValue);
    propOnChange?.(newValue);
  };

  const renderAutocomplete = (fieldValue: number[], fieldOnChange: (val: any) => void) => (
    <div className={classes.container}>
      <div className={classes.inputWrapper}>
       {label ? <label>{label}</label> : null}
        <Autocomplete
          className={classes.inputDate}
          multiple
          disableCloseOnSelect
          options={yearOptions}
          value={fieldValue || []}
          onChange={(_, value) => fieldOnChange(value)}
          PopperComponent={StyledPopper}
          getOptionLabel={(option) => option.toString()}
          renderInput={(params) => (
            <TextField
             {...params}
              placeholder={!localValue.length && (placeholder ?? "Select...")} label="" error={!!errorMessage} variant="outlined" 
              fullWidth size="small"
              sx={{
                '& ::placeholder': {
                  color: '#1c1c1ca6', // Màu chữ của placeholder
                  fontSize: '16px', // Kích thước chữ của placeholder
                  fontWeight: 500
                },
              }}
               />
          )}
          sx={{
            '& .MuiAutocomplete-tag': {
              backgroundColor: '#e6e6e6',
              color: '#333333',
              borderRadius: '4px',
              padding: '3px',
              height: 'auto'
            },
            '& .MuiAutocomplete-tag .MuiChip-deleteIcon': {
              color: 'black',
              fontSize: 18,
              '&:hover': {
                color: '#DE350B',
              },
            },
          }}
          renderOption={(props, option, { selected }) => (
            <li {...props} style={{ width: '25%', margin: '4px 0', textAlign: 'center' }}>
              <div
                style={{
                  padding: '3px',
                  borderRadius: 8,
                  backgroundColor: selected ? '#e6e6e6' : 'transparent',
                  color: selected ? '#333333' : '#000',
                  fontWeight: 400,
                  height:'auto'
                }}
              >
                {option}
              </div>
            </li>
          )}
          ListboxProps={{
            style: {
              display: 'flex',
              flexWrap: 'wrap',
              maxHeight: 300,
              overflowY: 'auto',
            },
          }}
        />
        {errorMessage ? <p className={classes.errorMessage}>{errorMessage}</p> : null}
      </div>
    </div>
  );

  return (
    <div className={classes.container}>
      {control && name ? (
        <Controller name={name} control={control} render={({ field }) => renderAutocomplete(field.value, field.onChange)} />
      ) : (
        renderAutocomplete(localValue, handleChange)
      )}
    </div>
  );
});

export default CustomMultiYearPicker;
